<template>
  <MenuComponent
    :custom_title="title">
    <template #navbar>
      <ClientReleasesNavBar
        :custom_title.sync="title"
        :features="features"
        @choeseType="choeseType"/>
    </template>
    <template
      v-if="false"
      #filter>
      <v-col cols="3">
        <FilterBar
          without_filter
          @applySearch="applySearch"/>
      </v-col>
    </template>
    <template #items>
      <v-row no-gutters>
        <v-col>
          <EmptyBlock
            v-if="!loading && (!filtred_releases || !filtred_releases.length )"
            :text="$t( 'Tenders.NoData' )"/>
          <div
            v-for="release in filtred_releases"
            :key="release.id"
            class="mt-5">
            <v-subheader class="black--text pb-2 px-0 h4-headline">
              "{{ release.releaseName }}", {{ formatDate(release.releaseDate) }}
            </v-subheader>
            <FeatureCard
              v-for="item in release.features"
              :key="item.id"
              client
              :item="item"
              no-index/>
          </div>
        </v-col>
      </v-row>
    </template>
    <template #loader>
      <InfinityUpdater
        ref="infinity_updater"
        :action="infinityLoad"
        :active="can_update"
        call-on-mount
        :loading="loading"/>
    </template>
    <template #updater/>
  </MenuComponent>
</template>
<script>
import FeatureCard from 'components/releases/FeatureCard.vue'
import MenuComponent from 'pages/templates/MenuComponent.vue'
import FilterBar from 'components/common/blocks/FilterBar.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'
import ClientReleasesNavBar from 'components/releases/ClientReleasesNavBar.vue'

import moment from 'moment'
import { releaseMixin } from 'mixins'

import { eventBus } from '@/main'

export default {
  name: 'ClientReleases',
  mixins: [ releaseMixin],
  data() {
    return {
      count: 0,
      loading: false,
      filtred_releases: [],
      features: [],
      type_filter: {},
      search: '',
      title: ''
    }
  },
  created() {
    this.$store.dispatch('getFeatureDetail')
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format('DD MMMM YYYY')
      }
    }
  },
  computed: {
    per_page() {
      return Math.floor(document.documentElement.clientHeight /  120) || 10
    },
    can_update() {
      return !this.loading && (this.featureDetail[this.type_filter?.value || 'all'].amount != this.count || !this.count)
    }
  },
  methods: {
    choeseType(filter) {
      let update = filter?.text != this.type_filter?.text
      this.type_filter = filter
      this.count = 0
      this.$refs.infinity_updater?.updateScrollCount(true)
      this.infinityLoad( update )
    },
    applySearch(search) {
      this.search = search ? this.$_.head(search).search : this.search
      // this.fiterReleases(items)
      this.$refs.infinity_updater?.updateScrollCount(true)
      this.filterBySearch()
    },
    async fiterReleases( update ) {
      if (!this.count || update) {
        this.features = []
      }
      let search_obj =  {
        take: this.per_page,
        skip: this.count,
      }

      if (this.type_filter?.type) { // comparison: 'equal',
        search_obj.type = this.type_filter?.type
      }

      let features = await this.$store.dispatch('getAllFeatures', search_obj),
        releases = []
      this.features.push(...features)

      this.filterBySearch(features , releases)
    },
    filterBySearch(features = [] , releases = []) {
      features = this.features.filter(feature => {
        return !this.search || this.$_.some(Object.entries(feature), ([key, value]) =>
          typeof value == 'string' && key != 'id' ? value.toLowerCase().includes(this.search?.toLowerCase()) : false)
      })

      features = this.$_.groupBy(features, 'releaseId')

      Object.values( features  ).forEach( elems => {
        releases.push({
          ...elems[0].releaseId,
          features: elems,
          releaseDate: elems[0].releaseDate,
          releaseName: elems[0].releaseName
        })
      })

      this.filtred_releases =  this.$_.sortBy(releases, ['releaseDate']).reverse()

      eventBus.$emit('finishLoadingContent', ['setPurchaseSettings'])
    },
    formatDate(value) {
      if (value) {
        let at = this.$t('Common.at'),
          main = (moment(value.slice(0, 10)).calendar().split(' ' + at + ' '))[0].toLowerCase()
        return main
      }
    },
    async infinityLoad(update) {
      if ( update || this.can_update) {
        this.loading = true
        await this.fiterReleases( update )
        this.loading = false
        this.count = this.features.length
      }
    },
  },
  components: {
    FilterBar,
    EmptyBlock,
    FeatureCard,
    MenuComponent,
    InfinityUpdater,
    ClientReleasesNavBar
  }
}
</script>
<style lang="scss" scoped>
.empty-block {
  border-radius: 8px;
}
</style>
